import { categoryConstants as constants } from '../constants';
import { helper } from '../helpers/helper';

const initialState = { categories: [], parents: [], themePackages: [], modelsResults: [], contractTypes: [], isLoading: [] };

export const category = (state, action) => {
    state = state || initialState;

    // GET CATEGORIES
    if (action.type === constants.GET_CATEGORIES_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_CATEGORIES_REQUEST]
        };
    }
    if (action.type === constants.GET_CATEGORIES_SUCCESS) {
        return {
            ...state,
            categories: action.categories,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_CATEGORIES_REQUEST)
        };
    }

    // GET PARENT CATEGORIES
    if (action.type === constants.GET_PARENT_CATEGORIES_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_PARENT_CATEGORIES_REQUEST]
        };
    }
    if (action.type === constants.GET_PARENT_CATEGORIES_SUCCESS) {
        return {
            ...state,
            parents: action.parents,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PARENT_CATEGORIES_REQUEST)
        };
    }

    // GET CATEGORY THEME PACKAGES
    if (action.type === constants.GET_THEME_PACKAGES_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_THEME_PACKAGES_REQUEST]
        };
    }
    if (action.type === constants.GET_THEME_PACKAGES_SUCCESS) {
        return {
            ...state,
            themePackages: action.themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_THEME_PACKAGES_REQUEST)
        };
    }

    // ADD CATEGORY THEME PACKAGE
    if (action.type === constants.ADD_THEME_PACKAGE_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.ADD_THEME_PACKAGE_REQUEST]
        };
    }
    if (action.type === constants.ADD_THEME_PACKAGE_SUCCESS) {
        return {
            ...state,
            themePackages: [...state.themePackages, action.themePackage],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.ADD_THEME_PACKAGE_REQUEST)
        };
    }

    // REMOVE CATEGORY THEME PACKAGE
    if (action.type === constants.REMOVE_THEME_PACKAGE_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.REMOVE_THEME_PACKAGE_REQUEST]
        };
    }
    if (action.type === constants.REMOVE_THEME_PACKAGE_SUCCESS) {

        let themePackages = state.themePackages.filter(x => x.id !== action.id);

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.REMOVE_THEME_PACKAGE_REQUEST)
        };
    }
    if (action.type === constants.REMOVE_THEME_PACKAGE_FAILURE) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.REMOVE_THEME_PACKAGE_REQUEST)
        };
    }

    // ADD OR UPDATE CATEGORY THEME
    if (action.type === constants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST]
        };
    }
    if (action.type === constants.ADD_OR_UPDATE_CATEGORY_THEME_SUCCESS) {

        let themePackages = state.themePackages.slice();
        let packagePos = themePackages.findIndex(x => x.id === action.id);
        let themePackage = Object.assign({}, themePackages[packagePos]);

        let categories = themePackage.categories.slice();
        let themePos = categories.findIndex(x => x.code === action.categoryTheme.code);

        //Add or update category to/in correct theme package in a pure way.
        if (themePos === undefined || themePos < 0) {
            categories.push(action.categoryTheme);
        }
        else {
            categories[themePos] = action.categoryTheme;
        }

        themePackage.categories = categories;
        themePackages[packagePos] = themePackage;

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST)
        };
    }
    if (action.type === constants.ADD_OR_UPDATE_CATEGORY_THEME_FAILURE) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST)
        };
    }

    // REMOVE CATEGORY THEME
    if (action.type === constants.REMOVE_THEME_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.REMOVE_THEME_REQUEST]
        };
    }
    if (action.type === constants.REMOVE_THEME_SUCCESS) {

        let themePackages = state.themePackages.slice();
        let packagePos = themePackages.findIndex(x => x.id === action.id);
        let themePackage = Object.assign({}, themePackages[packagePos]);

        let themePos = themePackage.categories.findIndex(x => x.code === action.categoryTheme.code);
        let categories = themePackage.categories.slice();
        categories.splice(themePos, 1);

        themePackage.categories = categories;
        themePackages[packagePos] = themePackage;

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.REMOVE_THEME_REQUEST)
        };
    }
    if (action.type === constants.REMOVE_THEME_FAILURE) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.REMOVE_THEME_REQUEST)
        };
    }

    // EDIT CATEGORY THEME PACKAGE
    if (action.type === constants.EDIT_THEME_PACKAGE_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.EDIT_THEME_PACKAGE_REQUEST]
        };
    }
    if (action.type === constants.EDIT_THEME_PACKAGE_SUCCESS) {

        //Update the instance in the theme packages list.
        let themePackages = state.themePackages.slice();
        let pos = themePackages.findIndex(x => x.id === action.themePackage.id);
        themePackages[pos] = action.themePackage;

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EDIT_THEME_PACKAGE_REQUEST)
        };
    }

    // ADD ORGANIZATION TO CATEGORY THEME PACKAGE
    if (action.type === constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST]
        };
    }
    if (action.type === constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_SUCCESS) {

        //Update the instance in the theme packages list.
        let themePackages = state.themePackages.slice();
        let pos = themePackages.findIndex(x => x.id === action.themePackage.id);
        themePackages[pos] = action.themePackage;

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST)
        };
    }

    // REMOVE ORGANIZATION FROM CATEGORY THEME PACKAGE
    if (action.type === constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST]
        };
    }
    if (action.type === constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_SUCCESS) {

        //Update the instance in the theme packages list.
        let themePackages = state.themePackages.slice();
        let pos = themePackages.findIndex(x => x.id === action.themePackage.id);
        themePackages[pos] = action.themePackage;

        return {
            ...state,
            themePackages,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST)
        };
    }

    // ### TEST TEXT ###
    if (action.type === constants.TEST_MODELS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.TEST_MODELS_REQUEST]
        };
    }
    if (action.type === constants.TEST_MODELS_SUCCESS) {
        return {
            ...state,
            modelsResults: action.modelsResults,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.TEST_MODELS_REQUEST)
        };
    }
    if (action.type === constants.TEST_MODELS_FAILURE) {
        return {
            ...state,
            modelsResults: [],
            error: action.error,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.TEST_MODELS_REQUEST)
        };
    }

    // ### CONTRACT TYPES ###
    if (action.type === constants.GET_CONTRACT_TYPES_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.GET_CONTRACT_TYPES_REQUEST]
        };
    }
    if (action.type === constants.GET_CONTRACT_TYPES_SUCCESS) {
        return {
            ...state,
            contractTypes: action.contractTypes,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_CONTRACT_TYPES_REQUEST)
        };
    }
    if (action.type === constants.GET_CONTRACT_TYPES_FAILURE) {
        return {
            ...state,
            contractTypes: [],
            error: action.error,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_CONTRACT_TYPES_REQUEST)
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/category.reducer.js